
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
import KeywordProtectedPage from './MyPage';
function Bestcabfrompune() {



    const cardData =
    {
        keyword: 'Best Cab From Pune To Murud Janjira',
        heading: 'Mauli Cabs: Best Cab From Pune To Murud Janjira',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Best Cab From Pune To Murud Janjira, ensuring a smooth and spiritual journey to the sacred Ashtavinayak temples. Whether you are on a religious pilgrimage or a peaceful family trip, we provide a variety of vehicles including sedans, SUVs, and premium cars. With professional drivers, transparent pricing, no hidden charges, and a commitment to safety, Mauli Cabs guarantees a hassle-free and enriching experience on your Ashtavinayak Darshan journey.',

        top: 'Top Places to Visit in Murud Janjira with Mauli Cabs',

"topPlaces": [
    {
        "title": "Murud Janjira Fort",
        "description": "The Murud Janjira Fort is an iconic sea fort located on an island off the coast of Murud, near Alibaug. Known for its impregnable defenses, this fort has witnessed many battles and remains a testament to the maritime power of the region."
    },
    {
        "title": "Dattagalli",
        "description": "Located near the Murud Janjira Fort, Dattagalli offers a peaceful escape with stunning views of the Arabian Sea. It’s a great spot for a relaxing stroll or for those looking to enjoy the natural beauty of the area."
    },
    {
        "title": "Kasa Fort",
        "description": "Situated a short distance from Murud, Kasa Fort is another historical site that holds significance in the region’s history. It provides beautiful panoramic views of the surrounding landscape and is a serene spot for nature lovers."
    },
    {
        "title": "Janjira Beach",
        "description": "Janjira Beach is a calm and pristine beach near Murud, ideal for relaxing, sunbathing, and swimming. The beach is less crowded compared to other coastal spots in Maharashtra, making it a perfect getaway."
    },
    {
        "title": "Haji Malang Dargah",
        "description": "The Haji Malang Dargah, located on a hilltop near Murud, is a sacred Muslim shrine. Pilgrims often visit the dargah for blessings, and it offers a stunning view of the surrounding area."
    },
    {
        "title": "Murud Janjira Beach",
        "description": "The beach near the fort is peaceful and less commercialized. It is ideal for a quiet getaway and offers beautiful views of the Murud Janjira Fort in the distance."
    },
    {
        "title": "Kundalika River",
        "description": "Kundalika River, flowing near Murud, offers thrilling water sports opportunities like river rafting. The river’s pristine surroundings and exciting adventures make it a popular spot for outdoor enthusiasts."
    },
    {
        "title": "Janjira Palace",
        "description": "The Janjira Palace, located on the fort, was once a royal residence. It stands as a reminder of the grandeur and cultural history of the fort and the region."
    },
    {
        "title": "Rajpuri Caves",
        "description": "Rajpuri Caves near Murud are historical caves and are believed to be linked with the ancient architectural heritage of the region. It’s a good place for exploring the history and enjoying a calm retreat."
    },
    {
        "title": "Kashid Beach",
        "description": "Located near Murud, Kashid Beach is known for its golden sand, clear waters, and scenic beauty. It’s an ideal spot for beach lovers to relax, enjoy water sports, and witness beautiful sunsets."
    }
],

"services": [
    {
        "name": "Best Cab Service from Pune to Murud Janjira",
        "description": "Mauli Cabs offers the best cab services from Pune to Murud Janjira, ensuring a comfortable, reliable, and timely journey. Explore the beautiful Murud Janjira fort with our professional drivers."
    },
    {
        "name": "Book Pune to Murud Janjira Taxi",
        "description": "Book your taxi from Pune to Murud Janjira with Mauli Cabs. We offer easy booking and ensure a smooth and safe ride to one of Maharashtra's most scenic destinations."
    },
    {
        "name": "Affordable Pune to Murud Janjira Cab",
        "description": "Mauli Cabs provides affordable cab services from Pune to Murud Janjira, making your journey to this historic coastal destination both budget-friendly and comfortable."
    },
    {
        "name": "Private Taxi from Pune to Murud Janjira",
        "description": "Travel privately from Pune to Murud Janjira with Mauli Cabs. Enjoy a personalized travel experience with professional drivers and a well-maintained vehicle, tailored to your preferences."
    },
    {
        "name": "Murud Janjira Trip by Cab from Pune",
        "description": "Mauli Cabs offers convenient and reliable cab services for your trip from Pune to Murud Janjira. Enjoy a smooth ride to explore the magnificent Murud Janjira fort and surrounding attractions."
    },
    {
        "name": "Pune to Murud Janjira One-Way or Round Trip",
        "description": "Mauli Cabs offers flexible taxi services for your journey from Pune to Murud Janjira, whether you're looking for a one-way ride or a round trip. We cater to your specific travel needs."
    },
    {
        "name": "Comfortable Taxi Ride to Murud Janjira",
        "description": "Experience a comfortable ride to Murud Janjira from Pune with Mauli Cabs. Our vehicles are well-maintained and air-conditioned, ensuring you travel in comfort and style."
    },
    {
        "name": "Group Travel to Murud Janjira",
        "description": "Mauli Cabs provides spacious vehicles for group travel to Murud Janjira. Whether it's a family trip or a group of friends, we offer the perfect vehicle for a comfortable journey."
    },
    {
        "name": "Luxury Cab for Murud Janjira Trip",
        "description": "Travel in luxury from Pune to Murud Janjira with Mauli Cabs' premium taxi services. Enjoy the highest levels of comfort, amenities, and a smooth ride to your destination."
    },
    {
        "name": "Murud Janjira Sightseeing by Taxi",
        "description": "Explore the beautiful Murud Janjira fort and surrounding sights with Mauli Cabs' sightseeing services. Our professional drivers will guide you through the best routes for an unforgettable experience."
    }
],

"tableData": [
    ["Best Cab Service from Pune to Murud Janjira", "Book Pune to Murud Janjira Taxi"],
    ["Affordable Pune to Murud Janjira Cab", "Private Taxi from Pune to Murud Janjira"],
    ["Murud Janjira Trip by Cab from Pune", "Pune to Murud Janjira One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Murud Janjira", "Group Travel to Murud Janjira"],
    ["Luxury Cab for Murud Janjira Trip", "Murud Janjira Sightseeing by Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers the best cab service for your Pune to Murud Janjira trip. Our drivers are committed to providing timely pickups and drop-offs, ensuring you reach Murud Janjira safely and on time, without any delays or hassle."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Murud Janjira journey, we offer a range of vehicles, from sedans to SUVs and premium cars. All vehicles are air-conditioned, spacious, and designed for comfort, ensuring you enjoy a pleasant ride to the coastal town."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are well-versed with the best routes to Murud Janjira, ensuring a smooth and safe journey. They are familiar with local roads and traffic patterns, making your travel stress-free and efficient."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable and transparent pricing for your Pune to Murud Janjira trip. We provide clear, upfront pricing with no hidden charges, so you can enjoy your ride without worrying about unexpected costs."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are well-maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols to ensure a safe and secure ride to Murud Janjira."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether you're planning an early morning departure or a late-night return, Mauli Cabs is available 24/7 for your Pune to Murud Janjira trip. Our customer service team is always ready to assist you with your booking at any time of day or night."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Murud Janjira cab with Mauli Cabs is quick and simple. You can book online through our website or mobile app, or contact our customer service team for personalized assistance with your booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Murud Janjira trip. Whether you're going for a relaxed getaway or planning a family outing, we can tailor the journey to suit your preferences."
    }
]











    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Murud Janjira with Mauli Cabs?',
            answer: 'Booking a cab for Murud Janjira is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Murud Janjira as your destination, then select your preferred vehicle. Alternatively, you can call our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Murud Janjira trip?',
            answer: 'Mauli Cabs offers a range of vehicles, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Choose the vehicle that fits your comfort and space requirements for the scenic trip to Murud Janjira.',
        },
        {
            question: 'Is the fare from Pune to Murud Janjira fixed?',
            answer: 'Yes, the fare for the trip is fixed and transparent. It includes tolls, taxes, and driver charges, so you’ll know the total fare upfront with no hidden costs.',
        },
        {
            question: 'How long does the journey from Pune to Murud Janjira take?',
            answer: 'The ride from Pune to Murud Janjira typically takes around 4 to 5 hours, depending on traffic and road conditions. Our drivers ensure a smooth and timely journey with scenic views along the way.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Murud Janjira route?',
            answer: 'Yes, Mauli Cabs drivers are experienced and familiar with the best routes to Murud Janjira. You can expect a safe, comfortable, and enjoyable trip.',
        },
        {
            question: 'Can I book a round trip from Pune to Murud Janjira?',
            answer: 'Yes, you can book both one-way and round trips. Just provide your return details when booking, and we will take care of the rest for you.',
        },
        {
            question: 'Can I stop for sightseeing or take detours along the way to Murud Janjira?',
            answer: 'Yes, we can customize your journey to include sightseeing stops along the way to Murud Janjira. Whether it’s a quick break or a longer detour to explore nearby attractions, we’ll make sure your trip is enjoyable.',
        },
        {
            question: 'Are your cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for comfort and cleanliness. We ensure a pleasant and relaxing ride for your trip to Murud Janjira.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Murud Janjira trip?',
            answer: 'Mauli Cabs offers competitive pricing, a range of vehicle options, professional drivers, and timely service. Whether for a relaxing beach day or a quick getaway, we ensure a comfortable and hassle-free trip to Murud Janjira.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rajesh Mehta",
            position: "Beach Enthusiast",
            text: "Our trip to Murud Janjira with Mauli Cabs was fantastic! The driver was knowledgeable about the route, and the car was clean and comfortable. The beach was beautiful, and we enjoyed every moment of the journey.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Neha Patil",
            position: "Family Traveler",
            text: "The ride to Murud Janjira was smooth and comfortable. The driver was friendly and professional, and the vehicle was perfect for our family. We had a wonderful time exploring the beach and surrounding areas. Highly recommended!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Best Cab From Pune to Murud Janjira by Mauli Cabs",
        "description": "Mauli Cabs offers the best cab service from Pune to Murud Janjira for a comfortable and scenic journey. Book private, luxury, or group taxis for one-way or round-trip travel with 24x7 online booking support. Enjoy a hassle-free trip to Murud Janjira, known for its beautiful beaches and historic fort.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
      
      

    return (
        <div>
            <GTag/>
<KeywordProtectedPage/>
<Helmet>
        <title>Best Cab From Pune to Murud Janjira | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book the best cab from Pune to Murud Janjira with Mauli Cabs. Affordable, comfortable, and reliable private, luxury, or group taxi options. One-way and round-trip services available 24x7."
        />
        <meta
          name="keywords"
          content="Best cab service from Pune to Murud Janjira, Book Pune to Murud Janjira taxi, Affordable Pune to Murud Janjira cab, Private taxi from Pune to Murud Janjira, Murud Janjira trip by cab from Pune, Pune to Murud Janjira one-way or round trip, Comfortable taxi ride to Murud Janjira, Group travel to Murud Janjira, Luxury cab for Murud Janjira trip, Murud Janjira sightseeing by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/12.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bestcabfrompune;